import { useQuery } from "react-query";
import { MacDataServices } from "../services/macDataServices";
import { postmortemApiEndpoint } from "../config";

export const useFetchMacDataBasedOnAppId = (app_id) => {
    const {fetchMacDataBasedOnApplicationId} = MacDataServices();
    const {
      data: macData,
      isError: macError,
      isLoading: macLoading,
      refetch: refetchMacData,
    } = useQuery(
      ["macData", app_id],
      () =>
        fetchMacDataBasedOnApplicationId(
          postmortemApiEndpoint,
          app_id
        ),
      {
        refetchOnWindowFocus: false,
        onSuccess: async (data) => {
          if (data) {
            let platformPortFolio = {
              id: data.portFolioName,
              label: data.portFolioName,
              value: data.portFolioName,
            };
  
            let platforms = {
              id: data.platformName,
              label: data.platformName,
              value: data.platformName,
            };
  
            let products = {
              id: data.productName,
              label: data.productName,
              value: data.productName,
            };
  
            let apps = {
              id: data.applicationName,
              label: data.applicationName,
              value: data.applicationName,
            };
  
            return {
              portfolio: platformPortFolio,
              platform: platforms,
              product: products,
              application: apps,
            };
          }
        },
  
        onError: () => {
          return {
            portfolio: { id: "", label: "", value: "" },
            platform: { id: "", label: "", value: "" },
            product: { id: "", label: "", value: "" },
            application: { id: "", label: "", value: "" },
          };
        },
      }
    );
  
    return { macData, macError, macLoading, refetchMacData };
  };